import React from "react";
import styles from "./tracking.module.css";
import { Modal, TextComponent } from "../../../../components";
import mapImg from "../../../../assets/images/staticImages/map.png";
import AntdTab from "../../../../components/AntdTab/AntdTab";

const TrackingModal = ({
  setLocationTracking,
  locationTracking,
  assets = [],
}) => {
  return (
    <Modal
      title={"Location Tracking"}
      open={locationTracking}
      onCancel={() => setLocationTracking(false)}
      width={"600px"}
    >
      {assets.length > 0 ? (
        <AntdTab
          items={assets.map((item) => ({
            key: `${item}`,
            label: `vehicle ${item}`,
            children: (
              <div className={styles.track_mainCont_tab}>
                <div className={styles.track_header}>
                  <TextComponent
                    text={"Vehicle is 500m away from set location"}
                    style={{ fontSize: "var(--mobile-sub-heading)" }}
                  />
                  <div className={styles.track_subHeader}>
                    <div
                      className={styles.track_subChildHeader}
                      style={{ borderRight: "1px solid var(--border-color)" }}
                    >
                      <TextComponent
                        text={"Lot A, Row 5"}
                        style={{
                          fontFamily: "Urbanist-bold",
                          fontSize: "var(--paragraph-font-size)",
                        }}
                      />
                      <TextComponent
                        text={"Location"}
                        style={{
                          fontSize: "var(--mobile-sub-heading)",
                          fontFamily: "Urbanist-regular",
                        }}
                      />
                    </div>
                    <div className={styles.track_subChildHeader}>
                      <TextComponent
                        text={"17th street"}
                        style={{
                          fontFamily: "Urbanist-bold",
                          fontSize: "var(--paragraph-font-size)",
                        }}
                      />
                      <TextComponent
                        text={"Current Location"}
                        style={{
                          fontSize: "var(--mobile-sub-heading)",
                          fontFamily: "Urbanist-regular",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.track_mapCont}>
                  <img
                    src={mapImg}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            ),
          }))}
        />
      ) : (
        <div className={styles.track_mainCont}>
          <div className={styles.track_header}>
            <TextComponent
              text={"Vehicle is 500m away from set location"}
              style={{ fontSize: "var(--mobile-sub-heading)" }}
            />
            <div className={styles.track_subHeader}>
              <div
                className={styles.track_subChildHeader}
                style={{ borderRight: "1px solid var(--border-color)" }}
              >
                <TextComponent
                  text={"Lot A, Row 5"}
                  style={{
                    fontFamily: "Urbanist-bold",
                    fontSize: "var(--paragraph-font-size)",
                  }}
                />
                <TextComponent
                  text={"Location"}
                  style={{
                    fontSize: "var(--mobile-sub-heading)",
                    fontFamily: "Urbanist-regular",
                  }}
                />
              </div>
              <div className={styles.track_subChildHeader}>
                <TextComponent
                  text={"17th street"}
                  style={{
                    fontFamily: "Urbanist-bold",
                    fontSize: "var(--paragraph-font-size)",
                  }}
                />
                <TextComponent
                  text={"Current Location"}
                  style={{
                    fontSize: "var(--mobile-sub-heading)",
                    fontFamily: "Urbanist-regular",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.track_mapCont}>
            <img
              src={mapImg}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default TrackingModal;
